/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamRunStateResponseSessionId } from './oralExamRunStateResponseSessionId';
import type { OralExamSessionPhase } from './oralExamSessionPhase';
import type { OralExamRunStateResponseConsentRecord } from './oralExamRunStateResponseConsentRecord';
import type { OralExamRunStateResponseConductAcknowledgedAt } from './oralExamRunStateResponseConductAcknowledgedAt';
import type { OralExamRunStateResponseConductPolicyVersion } from './oralExamRunStateResponseConductPolicyVersion';
import type { OralExamRunStateResponseIdPhotoBlobPath } from './oralExamRunStateResponseIdPhotoBlobPath';
import type { OralExamRunStateResponseIdSelfiePhotoBlobPath } from './oralExamRunStateResponseIdSelfiePhotoBlobPath';
import type { OralExamRunStateResponseSupervisorName } from './oralExamRunStateResponseSupervisorName';
import type { OralExamRunStateResponseSupervisorPhotoBlobPath } from './oralExamRunStateResponseSupervisorPhotoBlobPath';
import type { OralExamRunStateResponseSupervisorView } from './oralExamRunStateResponseSupervisorView';
import type { OralExamCurrentQuestion } from './oralExamCurrentQuestion';
import type { OralExamRunStateResponseCurrentQuestionIndex } from './oralExamRunStateResponseCurrentQuestionIndex';
import type { OralExamRunStateResponseCurrentQuestion } from './oralExamRunStateResponseCurrentQuestion';
import type { OralExamRunStateResponseStartedAt } from './oralExamRunStateResponseStartedAt';
import type { OralExamRunStateResponseConductPhase } from './oralExamRunStateResponseConductPhase';
import type { OralExamRunStateResponseExaminerReadyAt } from './oralExamRunStateResponseExaminerReadyAt';
import type { OralExamRunStateResponseStudentReadyAt } from './oralExamRunStateResponseStudentReadyAt';
import type { OralExamRunStateResponseFirstSeenAt } from './oralExamRunStateResponseFirstSeenAt';
import type { OralExamRunStateResponsePreflightLobbyReadyAt } from './oralExamRunStateResponsePreflightLobbyReadyAt';
import type { OralExamRunStateResponseOrientationCompletedAt } from './oralExamRunStateResponseOrientationCompletedAt';
import type { OralExamRunStateResponseEndedAt } from './oralExamRunStateResponseEndedAt';
import type { OralExamRunStateResponseEndReason } from './oralExamRunStateResponseEndReason';
import type { OralExamRunStateResponseQuestionMarkerStartedAt } from './oralExamRunStateResponseQuestionMarkerStartedAt';
import type { OralExamRunStateResponseQuestionDeadline } from './oralExamRunStateResponseQuestionDeadline';
import type { OralExamRunStateResponsePauseReason } from './oralExamRunStateResponsePauseReason';
import type { OralExamRunStateResponseStudentDoneAt } from './oralExamRunStateResponseStudentDoneAt';
import type { OralExamDriver } from './oralExamDriver';
import type { OralExamRunStateResponseOperationalFault } from './oralExamRunStateResponseOperationalFault';
import type { OralExamRunStateResponseRecordingStatus } from './oralExamRunStateResponseRecordingStatus';
import type { OralExamSupervisorStatus } from './oralExamSupervisorStatus';
import type { OralExamRunStateResponseSupervisorBroadcast } from './oralExamRunStateResponseSupervisorBroadcast';
import type { OralExamMode } from './oralExamMode';
import type { OralExamRunStateResponseStartAuthority } from './oralExamRunStateResponseStartAuthority';
import type { OralExamRunStateResponseIdVerification } from './oralExamRunStateResponseIdVerification';
import type { OralExamMediaIntegrity } from './oralExamMediaIntegrity';
import type { OralExamRunStateResponseIntegrityBudget } from './oralExamRunStateResponseIntegrityBudget';
import type { OralExamRunStateResponseStageGate } from './oralExamRunStateResponseStageGate';
import type { OralExamRunStateResponseLecturerAbsentAt } from './oralExamRunStateResponseLecturerAbsentAt';
import type { OralExamRunStateResponseBookingCancellationReason } from './oralExamRunStateResponseBookingCancellationReason';
import type { OralExamRunStateResponseBrieferId } from './oralExamRunStateResponseBrieferId';
import type { OralExamRunStateResponseSlotOwnerId } from './oralExamRunStateResponseSlotOwnerId';
import type { OralExamRunStateResponseEtag } from './oralExamRunStateResponseEtag';
import type { OralExamRunStateResponseVoidCause } from './oralExamRunStateResponseVoidCause';

/**
 * Oral exam run state returned by control and polling endpoints.
 */
export interface OralExamRunStateResponse {
  sessionId?: OralExamRunStateResponseSessionId;
  state: string;
  sessionPhase?: OralExamSessionPhase;
  consentRecord?: OralExamRunStateResponseConsentRecord;
  conductAcknowledgedAt?: OralExamRunStateResponseConductAcknowledgedAt;
  conductPolicyVersion?: OralExamRunStateResponseConductPolicyVersion;
  idPhotoBlobPath?: OralExamRunStateResponseIdPhotoBlobPath;
  idSelfiePhotoBlobPath?: OralExamRunStateResponseIdSelfiePhotoBlobPath;
  supervisorName?: OralExamRunStateResponseSupervisorName;
  supervisorPhotoBlobPath?: OralExamRunStateResponseSupervisorPhotoBlobPath;
  supervisorView?: OralExamRunStateResponseSupervisorView;
  selectedQuestionIds: string[];
  draftSelectedQuestionIds: string[];
  draftQuestions?: OralExamCurrentQuestion[];
  currentQuestionIndex?: OralExamRunStateResponseCurrentQuestionIndex;
  currentQuestion?: OralExamRunStateResponseCurrentQuestion;
  startedAt?: OralExamRunStateResponseStartedAt;
  committed?: boolean;
  conductPhase?: OralExamRunStateResponseConductPhase;
  examinerReadyAt?: OralExamRunStateResponseExaminerReadyAt;
  studentReadyAt?: OralExamRunStateResponseStudentReadyAt;
  firstSeenAt?: OralExamRunStateResponseFirstSeenAt;
  preflightLobbyReadyAt?: OralExamRunStateResponsePreflightLobbyReadyAt;
  orientationCompletedAt?: OralExamRunStateResponseOrientationCompletedAt;
  endedAt?: OralExamRunStateResponseEndedAt;
  endReason?: OralExamRunStateResponseEndReason;
  secondsPerQuestion: number;
  questionCount: number;
  questionMarkerStartedAt?: OralExamRunStateResponseQuestionMarkerStartedAt;
  questionDeadline?: OralExamRunStateResponseQuestionDeadline;
  isPaused?: boolean;
  pauseReason?: OralExamRunStateResponsePauseReason;
  studentDoneAt?: OralExamRunStateResponseStudentDoneAt;
  driver?: OralExamDriver;
  operationalFault?: OralExamRunStateResponseOperationalFault;
  recordingRequired?: boolean;
  recordingStatus?: OralExamRunStateResponseRecordingStatus;
  supervisorStatus?: OralExamSupervisorStatus;
  supervisorBroadcast?: OralExamRunStateResponseSupervisorBroadcast;
  capacity: number;
  mode: OralExamMode;
  startAuthority?: OralExamRunStateResponseStartAuthority;
  requiresEvaluation?: boolean;
  idVerification?: OralExamRunStateResponseIdVerification;
  mediaIntegrity?: OralExamMediaIntegrity;
  integrityBudget?: OralExamRunStateResponseIntegrityBudget;
  stageGate?: OralExamRunStateResponseStageGate;
  lecturerAbsentAt?: OralExamRunStateResponseLecturerAbsentAt;
  bookingCancellationReason?: OralExamRunStateResponseBookingCancellationReason;
  brieferId?: OralExamRunStateResponseBrieferId;
  slotOwnerId?: OralExamRunStateResponseSlotOwnerId;
  etag?: OralExamRunStateResponseEtag;
  voidCause?: OralExamRunStateResponseVoidCause;
}
